import { create } from 'zustand';

// Page-local multi-row selection for the Operations Dashboard v2 (client-only,
// URL-independent per FR-3.4). Deliberately separate from the singleton
// `useOperationsUIStore` the /operations list uses, so selection never bleeds
// between the two surfaces.
type DashboardSelectionStore = {
  selected: Set<string>;
  toggle: (id: string) => void;
  setSelected: (ids: string[], selected: boolean) => void;
  clear: () => void;
};

export const useDashboardSelection = create<DashboardSelectionStore>((set) => ({
  selected: new Set(),
  toggle: (id) =>
    set(({ selected }) => {
      const next = new Set(selected);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return { selected: next };
    }),
  setSelected: (ids, value) =>
    set(({ selected }) => {
      const next = new Set(selected);
      for (const id of ids) {
        if (value) {
          next.add(id);
        } else {
          next.delete(id);
        }
      }
      return { selected: next };
    }),
  clear: () => set({ selected: new Set() }),
}));
